var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:[
    'text-none' + ' big-button' + " " + _vm.textColor + "--text",
    { 'rounded-lg': _vm.rounded } ],attrs:{"large":"","color":_vm.dColor,"text":_vm.dText,"min-width":120},on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }